'use strict';

import { getVueTemplate } from '../../../_imports/utils/utils.common';
import ResourceSpeaker from './resource-speaker.vue';

const speakers = {
    template: getVueTemplate('resource-speakers'),
    components: {
        ResourceSpeaker
    },
    props: {
        speakers: Object,
        sectionTitle: String,
        premiumFullSize: Boolean
    },
    data() {
        return {
            activeSpeaker: null
        }
    },
    computed: {
        shouldIncludeCompanyNameInPositionTitle() {
            return this.speakers.appendCompanyNameToPositionTitle;
        }
    },
    methods: {
        hasPremium() {
            return this.speakers.people && this.speakers.people.some(speaker => speaker.premium);
        },
        isTabActive(speaker) {
            return this.activeSpeaker == speaker;
        },
        setActiveTab(speaker) {
            if (speaker.isActive) {
                this.activeSpeaker = speaker;
            } else {
                this.activeSpeaker = null;
            }
        }
    }
};

export default speakers;